import { isNotEmpty } from '@qsxy/element-plus-react';
import { numberList, specialList, wordList } from './constants';

type map = <U, T>(opstion: {
	array: U[];
	range: number;
	matchList: T[];
	tokenMap: (updateItem: T, token: U, index: number) => T;
	breakKey?: string;
	arrayMap?: (item: U, index: number) => void;
}) => T[];

/**
 * match array and set
 */
export const setArrayMatch: map = ({ array, range, matchList, breakKey, tokenMap, arrayMap }) => {
	const tokenLen = array.length;
	for (let tokenIndex = tokenLen - 1; tokenIndex >= 0; tokenIndex--) {
		const arrayToken = array[tokenIndex];
		arrayMap && arrayMap(arrayToken, tokenIndex);
		for (let findIndex = range - 1; findIndex >= 0; findIndex--) {
			matchList = matchList.map(item => tokenMap(item, arrayToken, findIndex));
		}
		if (breakKey && !matchList.map(e => (e as any)[breakKey]).includes(false)) {
			break;
		}
	}
	return matchList;
};

export const passwordBreakKey = 'isMatch';
export type IpasswordRule = {
	list: string[];
	isMatch: boolean;
	name: string;
};
export const defaultPasswordRuleList = [
	{ name: 'special', list: specialList },
	{ name: 'num', list: numberList },
	{ name: 'word', list: wordList },
];

type PickValue<T, K extends keyof T> = T[K];

export const getRuleMatchResult: (
	customRule: IpasswordRule[],
	inputValue: string,
	disableDefaultRule?: boolean,
	breakKey?: string,
) => {
	list: IpasswordRule[];
	map: Map<PickValue<IpasswordRule, 'name'>, boolean>;
	matchCount: number;
	invaildWord: boolean;
} = (customRule, inputValue, disableDefaultRule = true, breakKey) => {
	let ruleList = [...(disableDefaultRule ? defaultPasswordRuleList : []), ...customRule].map(item => ({ ...item, [passwordBreakKey]: false }));
	const range = Math.max(...ruleList.map(ruleItem => ruleItem.list.length));
	let matchCount = 0;
	ruleList = setArrayMatch<string, IpasswordRule>({
		array: inputValue.split(''),
		range,
		matchList: ruleList,
		// not breakKey  full match
		breakKey: breakKey === void 0 ? passwordBreakKey : breakKey,
		tokenMap: (ruleItem, inputToken, findIndex) => {
			const match = ruleItem?.list[findIndex] === inputToken;
			if (match) {
				matchCount++;
				return { ...ruleItem, isMatch: true };
			}
			return ruleItem;
		},
	});
	return {
		list: ruleList,
		map: new Map(ruleList.map(e => [e.name, e[passwordBreakKey]])),
		matchCount,
		// 想要获取这个值，必须breakKey设置为空字符，如果提前退出会导致提前中止条件
		// To get this value, breakkey must be set to null string
		invaildWord: matchCount !== inputValue.length,
	};
};

export const isMatchForceResultConfig = (config: MatchResultConfig, matchNum: number, inputValueLen: number) => {
	return matchNum === config.matchNum && inputValueLen >= config.min && inputValueLen <= config.max && (config.need !== undefined ? config.need : true);
};

export type MatchResultConfig = {
	min: number;
	max: number;
	matchNum: number;
	value: IpasswordForce;
	need?: boolean;
	back?: IpasswordForce;
};
export type IpasswordForce = false | 'high' | 'middle' | 'low';

export function WeakPassword(username = '', pwd = '') {
	const isDigit = /^.*[0-9]+.*/; //数字
	// const isLowerCase = /^.*[a-z]+.*/; // isLowerCase 小写字母
	// const isUpperCase = /^.*[A-Z]+.*/; // isUpperCase 大写字母

	//密码中不能包含有连续3位及以上顺序(或逆序)数字(如：密码中不能包含123或321等)。
	for (let i = 0; i < pwd.length - 2; i++) {
		if (!isDigit.test(pwd.substring(i, i + 1)) || !isDigit.test(pwd.substring(i + 1, i + 2) + '') || !isDigit.test(pwd.substring(i + 2, i + 3) + '')) {
			continue;
		}
		const no1 = Number(pwd.substring(i, i + 1));
		const no2 = Number(pwd.substring(i + 1, i + 2));
		const no3 = Number(pwd.substring(i + 2, i + 3));

		if (no1 + 1 == no2 && no2 + 1 == no3) {
			return '密码不能包含连续三位数字';
		}
		if (no2 + 1 == no1 && no3 + 1 == no2) {
			return '密码不能包含连续三位数字(逆序)';
		}
	}

	for (let i = 0; i < pwd.length - 2; i++) {
		const no1 = pwd.charAt(i).charCodeAt(0) + 0;
		const no2 = pwd.charAt(i + 1).charCodeAt(0) + 0;
		const no3 = pwd.charAt(i + 2).charCodeAt(0) + 0;
		if (no1 + 1 == no2 && no2 + 1 == no3) {
			return '密码不能包含连续三位字母';
		}
		if (no2 + 1 == no1 && no3 + 1 == no2) {
			return '密码不能包含连续三位字母(逆序)';
		}
	}

	if (isKeyBoardContinuousChar(pwd)) {
		return '密码不能包含3个及以上键盘连续字符';
	}

	if (isNotEmpty(username) && pwd.indexOf(username) > -1) {
		return '密码不能包含用户名';
	}

	//密码中不能包含有连续3位及以上重复字符，(如：密码中不能包含888、aaa 或AAA或或 $$$$等3位及以上的重复字符)。
	for (let i = 0; i < pwd.length - 2; i++) {
		if (pwd.charAt(i) == pwd.charAt(i + 1) && pwd.charAt(i + 1) == pwd.charAt(i + 2)) {
			return '密码中不能包含连续3位及以上相同字符';
		}
	}

	// const cont = /^.*admin.*$/;
	// const cont2 = /^.*pass.*$/;
	// //禁忌词不区分大小写不能作为密码的一部分存在于密码中(如：admin, pass)。
	// if (cont.test(pwd) || cont2.test(pwd)) {
	//   return '密码中不能包含禁忌词(如：admin, pass)';
	// }

	const count = [/[A-Z]/, /[a-z]/, /\d/, /[!@#$%^&*(),.?":{}|<>]/].filter(regex => regex.test(pwd)).length;
	if (count < 3) {
		return '密码必须包含大写字母、小写字母、数字、特殊字符中的至少三种';
	}

	return false;
}

// 键盘相邻字符校验
export function isKeyBoardContinuousChar(str) {
	const c1 = [
		['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
		['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '{', '}', '|'],
		['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ':', '"'],
		['z', 'x', 'c', 'v', 'b', 'n', 'm', '<', '>', '?'],
	];
	const c2 = [
		['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
		['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', '\\'],
		['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'"],
		['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'],
	];
	str = str.split('');
	//获取坐标位置
	const y = [];
	const x = [];
	for (let c = 0; c < str.length; c++) {
		y[c] = 0; //当做~`键处理
		x[c] = -1;
		for (let i = 0; i < c1.length; i++) {
			for (let j = 0; j < c1[i].length; j++) {
				if (str[c] == c1[i][j]) {
					y[c] = i;
					x[c] = j;
				}
			}
		}
		if (x[c] != -1) {
			continue;
		}
		for (let i = 0; i < c2.length; i++) {
			for (let j = 0; j < c2[i].length; j++) {
				if (str[c] == c2[i][j]) {
					y[c] = i;
					x[c] = j;
				}
			}
		}
	}
	//匹配坐标连线
	for (let c = 1; c < str.length - 1; c++) {
		if (y[c - 1] == y[c] && y[c] == y[c + 1]) {
			if ((x[c - 1] + 1 == x[c] && x[c] + 1 == x[c + 1]) || (x[c + 1] + 1 == x[c] && x[c] + 1 == x[c - 1])) {
				return true;
			}
		} else if (x[c - 1] == x[c] && x[c] == x[c + 1]) {
			if ((y[c - 1] + 1 == y[c] && y[c] + 1 == y[c + 1]) || (y[c + 1] + 1 == y[c] && y[c] + 1 == y[c - 1])) {
				return true;
			}
		}
	}
	return false;
}
